import { AuthResponse, MccsRoles } from '@/@types/generated'
import { hasRole } from '@/components/Atoms/Permissions'
import { InternalRoles } from '../utils'
import { Feature } from './feature'
import { LicensingAgentsFeature } from './licensing-agents'
import { InsuranceFeature } from './insurance'

export const AutonomousVehiclesFeature = {
  // Roles that are eligible for the Automated Motor Vehicle feature
  Roles: [
    MccsRoles.AUTONOMOUS_VEHICLE_OWNER,
    MccsRoles.AUTONOMOUS_VEHICLE_USER,
  ],

  // Determine if the feature is enabled for the given user
  isEnabled: (user: AuthResponse | null): boolean =>
    hasRole(AutonomousVehiclesFeature.Roles, user),

  // Sub-features
  Application: {
    // Anyone can apply for an AV, UNLESS:
    // - They are already a Licensing Agency user
    // - They are an insurance user
    // - They are an internal user
    isEnabled: (user: AuthResponse | null): boolean =>
      !hasRole(
        [
          ...LicensingAgentsFeature.Roles,
          ...InsuranceFeature.Roles,
          ...InternalRoles,
        ],
        user
      ),
  } satisfies Feature,

  // Who can manage and make changes to the AV account?
  Manage: {
    isEnabled: (user: AuthResponse | null): boolean =>
      hasRole(
        [
          MccsRoles.CREDENTIALING_ADMIN,
          MccsRoles.CREDENTIALING,
          MccsRoles.AUTONOMOUS_VEHICLE_OWNER,
        ],
        user
      ),
  } satisfies Feature,

  // Who can manage and make changes to the AV vehicles?
  Vehicles: {
    isEnabled: (user: AuthResponse | null): boolean =>
      hasRole(
        [
          MccsRoles.CREDENTIALING_ADMIN,
          MccsRoles.CREDENTIALING,
          MccsRoles.AUTONOMOUS_VEHICLE_OWNER,
          MccsRoles.AUTONOMOUS_VEHICLE_USER,
        ],
        user
      ),
  } satisfies Feature,

  // Who can certify AV applications
  Certify: {
    isEnabled: (user: AuthResponse | null): boolean =>
      // Only the Owner
      hasRole([MccsRoles.AUTONOMOUS_VEHICLE_OWNER], user),
  } satisfies Feature,
} satisfies Feature
